export const getValueWithCustomDecimals = (value:number) => {
    
    if(value == null){
        return '-'
    }
    
    if(isNaN(value)){
        return value
    }
    let stringValue = value.toString().split('.')[0];
    let afterCommaValues = 2; //por default acorto a 2 caracteres
    if(stringValue.length >= 3){
        //si el numero es centena o mayor
        //acorto a 1 caracter
        afterCommaValues = 1
    }
    return parseFloat(value.toFixed(afterCommaValues)).toString()
}

export const milisecondsToTimestamp = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  }

  export const nullOrEmptyFormatter = value => {
    if (value == null || value === '') {
        return '-';
    }
    return value;
}